import React from 'react';
interface IProps{
    error: any,
    errorInfo: any
}

const Error: React.FC<IProps> = ({error, errorInfo}) => {
    return(
        <div>
            <h1>Something Went Wrong</h1>
            <details style={{ whiteSpace: 'pre-wrap' }}>
                { error && error.toString() }
                <br />
                { errorInfo && errorInfo.componentStack }
            </details>
        </div>
    )
}

export {
    Error
}